import { Edit, Loader2, RefreshCw, X } from 'lucide-react'
import React, { useState, useEffect } from 'react'
import HandleEntry from '../Common/HandleEntry';
import HandleExit from '../Common/HandleExit';
// import HandlePayment from '../Common/HandlePayment';
import leftarrow from "../../assets/left-arrow 1.svg";
import FormatTime from '../Common/FormatTime';
import FormatDate from '../Common/FormatDate.jsx';
import { usePayment } from '../../context/PaymentContext.jsx';
import profile from "../../assets/profile.png"
import axios from 'axios';
import ConfirmModal, {
  RegenerateIcon,
  ApproveIcon,
  RejectIcon,
} from './ConfirmModal.jsx';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const ReferralPayoutFile = () => {
  const { listPayoutFile, regeneratePayoutFile, submitPayoutFile, editWorkerListingData } = usePayment();

  const [loading, setLoading]                         = useState(false);
  const [selectedRecord, setSelectedRecord]           = useState([]);
  const [showEntryModal, setShowEntryModal]           = useState(false);
  const [showExitModal, setShowExitModal]             = useState(false);
  const [paymentEditModal, setPaymentEditModal]       = useState({ isOpen: false, record: null });
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [selectedAttendanceId, setSelectedAttendanceId]   = useState(null);
  const [retryingPayments, setRetryingPayments]       = useState({});
  const [isUTVMember,setIsUTVMember]                                 = useState(false);
  const [showSuccessModal, setShowSuccessModal]       = useState(false);
  const [showApprovalSuccessModal, setShowApprovalSuccessModal] = useState(false);
  const [showapprovalrejectmodal, setshowapprovalrejectmodal]   = useState(false);
  const [filestatus, setfilestatus]                   = useState("");
  const [editable, seteditable]                       = useState(false);
  const [response, setresponse]                       = useState(null);
  const [selectedStatus, setSelectedStatus]           = useState("");
  const [fileName, setfileName] = useState("");
  const [fileId, setfileId] = useState("");
  const [showreferlistingmodal, setshowreferlistingmodal] = useState(false);
 const [referralRecord, setReferralRecord] = useState([]);

  // ── Remarks state ─────────────────────────────────────────────────────────
  const [showRemarksModal, setShowRemarksModal] = useState(false);
  const [remarks, setRemarks]                   = useState("");

  // ── Confirmation modal state ──────────────────────────────────────────────
  const [activeConfirm, setActiveConfirm] = useState(null);
  const openConfirm  = (key) => setActiveConfirm(key);
  const closeConfirm = ()    => setActiveConfirm(null);
  const [typepayout, settypepayout] = useState("")

  // ── Edited rows ───────────────────────────────────────────────────────────
  const [editedRowIds, setEditedRowIds] = useState(new Set());

  // ── Table / summary ───────────────────────────────────────────────────────
  const [tableData, setTableData]   = useState([]);
  const [summaryData, setSummaryData] = useState({
    uniqueWorkers: 0, totalShifts: 0, totalGross: 0,
    totalDeductions: 0, total_additional_Deductions: 0,
    totalPromotions: 0, totalPayout: 0,
  });

  // ── Collapse ──────────────────────────────────────────────────────────────
  const [collapsedDepts, setCollapsedDepts] = useState({});
  const toggleDept = (deptId) =>
    setCollapsedDepts(prev => ({ ...prev, [deptId]: !prev[deptId] }));

  // ── Step 1: Parse URL once ────────────────────────────────────────────────
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const role   = params.get("role");
    setSelectedStatus(role ?? "");
  }, []);

  // ── Step 2: Fetch user from verify-token ──────────────────────────────────
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem("superadmintoken");
        const res   = await axios.get(`${BASE_URL}/lenskart/verify-token`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.data?.success && res.data?.user) {
          localStorage.setItem("userData", JSON.stringify(res.data.user));
          setresponse(res.data);
          setIsUTVMember(res.data?.user?.UTVMember)
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchUserData();
  }, [BASE_URL]);

  // ── Step 3: Fetch payout data only when BOTH response + selectedStatus ready
useEffect(() => {
  if (!response?.user) return; //  only block on missing user
  
  const params        = new URLSearchParams(window.location.search);
  const handleRowClick          = (userId) => window.open(`/lkart/superadmin/attendance-history/${userId}`, "_blank");
  const payoutfilesid = params.get("id");
  setfileId( params.get("id"));
  const payouttype    = params.get("payout_type");
  settypepayout(payouttype);

  if (!payoutfilesid) return;

  fetchPayoutData(payoutfilesid, selectedStatus, response.user.role, payouttype);
}, [response, selectedStatus]);

  // ── Fetch payout data ─────────────────────────────────────────────────────
// ── Fetch payout data ─────────────────────────────────────────────────────
const fetchPayoutData = async (payoutfilesid, role, userRole, payouttype) => {
  try {
    setLoading(true);
    const data = await listPayoutFile({ payoutfiles_id: payoutfilesid, payout_type: payouttype });
    if (data?.success) {
      setTableData(data.data ?? []);         // flat array directly
      setfilestatus(data.payoutFileStatus);
      setfileName(data.fileName);
      setSummaryData({
        uniqueWorkers:       data.summary?.totalWorkers ?? 0,
        totalShifts:         data.summary?.totalShifts  ?? 0,
        totalreferralamount: data.summary?.totalAmount  ?? 0,
        totalrefercount:     data.summary?.totalReferCount ??0,
        totalincentiveamount:data.summary?.totalIncentive??0
      });
    }
  } catch (error) {
    console.error("Error fetching payout data:", error);
  } finally {
    setLoading(false);
  }
};

const fetchReferralList = async (workerId, fileId, row) => {
  try {
    const token = localStorage.getItem("superadmintoken");
    const res = await axios.get(
      `${BASE_URL}/lenskart/list-referred-workers/${workerId}`,
      {
        params: { fileId },
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    if (res.data?.success) {
      setReferralRecord({
        name: row.name,
        totalReferCount: res.data.data.totalReferrals,
        referrals: res.data.data.referredWorkers,
        referralAmount: row.totalAmount,
      });
      setshowreferlistingmodal(true);
    }
  } catch (error) {
    console.error("Error fetching referral list:", error);
  }
};


  // ── Derived flags (for rendering) ────────────────────────────────────────
//   const isadmin        = response?.user?.role === "Admin";
//   const isSuperadmin   = response?.user?.role === "super_admin";
//   const hasPayoutGen   = selectedStatus === "Payout Generator";
//   const hasPayoutApproval = selectedStatus === "Payout Approver";

  // ── Action handlers ───────────────────────────────────────────────────────
const fetchlistingdata = async () => {
  const params        = new URLSearchParams(window.location.search);
  const payoutfilesid = params.get("id");
  const payouttype    = params.get("payout_type");

  console.log("payoutfilesid:", payoutfilesid); //  debug
  console.log("payouttype:", payouttype);        // debug

  if (!payoutfilesid) return; // if this triggers, nothing runs below

  const data = await listPayoutFile({ 
    payoutfiles_id: payoutfilesid, 
    payout_type: payouttype  // will be null if param missing
  });
};


  const handleRowClick          = (userId) => window.open(`/lkart/superadmin/attendance-history/${userId}`, "_blank");


  // ─────────────────────────────────────────────────────────────────────────
  return (
    <>
    {isUTVMember &&
      <div className="p-7 h-screen overflow-hidden flex flex-col bg-gray-50">

<h1 className="font-bold text-xl mb-2 text-center pt-10 pb-2 flex-shrink-0">
  {fileName}
</h1>

        {/* ── Summary ── */}
        <div className="mb-4 bg-white rounded-lg shadow-sm p-3 flex-shrink-0">
          <h2 className="font-bold text-s text-black mb-2">Payout Summary</h2>
          <div className="flex flex-wrap items-center gap-x-8 gap-y-1">
            {[
              { color: 'bg-yellow-500',  label: 'Total Unique Workers :', value: summaryData.uniqueWorkers,               prefix: ''  },
              { color: 'bg-pink-500',   label: 'Total Shifts :',          value: summaryData.totalShifts,                prefix: ''  },
...(typepayout === "referral" ? [{ color: 'bg-blue-400', label: 'Total Refer Count :', value: summaryData.totalrefercount, prefix: '' }] : []),
{ color: 'bg-green-400', label: typepayout === "referral" ? 'Total Referral Amount :' : 'Total Incentive Amount :', value: typepayout === "referral" ? summaryData.totalreferralamount : summaryData.totalincentiveamount, prefix: '₹' },
            ].map(({ color, label, value, prefix }) => (
              <div key={label} className="flex items-center gap-1">
                <span className={`w-1.5 h-1.5 rounded-full ${color} flex-shrink-0`} />
                <span className="text-gray-600 text-xs">{label}</span>
                <span className="font-semibold text-gray-900 text-xs">{prefix}{value}</span>
              </div>
            ))}
          </div>
        </div>

        {/* ── Table + Buttons ── */}
        <div className="flex-1 flex flex-col min-h-0">
          {loading ? (
            <div className="flex items-center justify-center flex-1">
              <div className="flex flex-col items-center gap-2">
                <Loader2 className="h-8 w-8 animate-spin text-indigo-600" />
                <p className="text-gray-500 text-sm">Loading payout data...</p>
              </div>
            </div>
          ) : (
            <div className="max-h-[78vh] overflow-y-auto overflow-x-auto relative">
              <table className="w-full text-xs border-collapse">
                <thead className="sticky top-0 bg-white shadow-md z-[50]">
                  <tr className="bg-gray-100">
                    <th className="p-1.5 text-left text-xs">Name <br />(Phone No.)</th>
                    <th className="p-1.5 text-center text-xs">Total Shifts</th>
                    <th className="p-1.5 text-center text-xs">Payment Month</th>
                    {typepayout === "referral" && (
  <th className="p-1.5 text-center text-xs">Total Referral Count</th>
)}
                    <th className="p-1.5 text-center text-xs">
  {typepayout === "referral" ? "Referral Amount" : "Incentive Amount"}
</th>
                    
                  </tr>
                </thead>
{/* // ── Table tbody ─────────────────────────────────────────────────────────── */}
<tbody>
  {tableData.length === 0 ? (
    <tr>
      <td colSpan={5} className="text-center p-8 text-gray-400 text-sm">
        No payout data found
      </td>
    </tr>
  ) : (
    tableData.map((record) => (   // flat map, no dept wrapper
      <tr
        key={record.referralPayoutId}
        className="border-b h-12 cursor-pointer transition-colors duration-300 bg-white hover:bg-gray-50"
      >
        {/* Name + Phone */}
        <td className="p-1.5 text-left min-w-[120px]"
        onClick={() => handleRowClick(record.user_id)}>
          <div className="flex items-center gap-1.5">
            <img
              src={record.image || profile}
              alt="Profile"
              style={{
                width: 28, height: 28,
                borderRadius: '50%',
                objectFit: 'cover',
                border: '2.5px solid #ccc',
              }}
            />
            <div>
              <div className="font-medium text-xs">{record.name}</div>
              <div className="text-gray-500" style={{ fontSize: 10 }}>{record.phone}</div>
            </div>
          </div>
        </td>

        {/* Total Shifts*/}
        <td className="p-1.5 text-center whitespace-nowrap">
          <span className="font-medium text-xs">{record.totalShifts}{record.shiftCount}</span>
        </td>

        {/* Payment Month*/}
        <td className="p-1.5 text-center whitespace-nowrap">
          <span className="font-medium text-xs">{record.month}</span>
        </td>

        {/* Total Referral Count */}
{typepayout === "referral" && (
  <td
    className="p-1.5 text-center text-blue-700 whitespace-nowrap cursor-pointer"
    onClick={() => {
      setshowreferlistingmodal(true);
      fetchReferralList(record.referrerId, fileId, record);
    }}
  >
    <span className="font-medium text-xs">{record.totalReferCount}</span>
  </td>
)}

        {/* Referral Amount*/}
        <td className="`p-1.5 text-center whitespace-nowrap` ">
          <span className={`font-medium text-xs rounded-full px-2 py-1  ${
                                      record.paymentStatus === "success" ? "bg-green-100 text-green-600"
                                      : record.paymentStatus === "failed"  ? "bg-red-100 text-red-600"
                                      : "text-blue-600"
                                    }`}>₹{record.totalAmount}{record.totalIncentive}</span>
        </td>
      </tr>
    ))
  )}
</tbody>
              </table>

            </div>
          )}
        </div>

        {/* ── Referral Listing Modal ── */}
{showreferlistingmodal && referralRecord && (
  <div
    className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40"
    onClick={() => setshowreferlistingmodal(false)}
  >
    <div
      className="bg-white rounded-xl shadow-xl w-full max-w-md mx-4 max-h-[80vh] flex flex-col"
      onClick={(e) => e.stopPropagation()}
    >
      {/* Header */}
      <div className="flex items-center justify-between px-5 py-4 border-b">
        <div>
          <h2 className="font-semibold text-sm text-gray-900">
            Referred by {referralRecord.name}
          </h2>
          <p className="text-xs text-gray-500 mt-0.5">
            {referralRecord.totalReferCount} referral
            {referralRecord.totalReferCount !== 1 ? "s" : ""}
          </p>
        </div>
        <button
          onClick={() => setshowreferlistingmodal(false)}
          className="text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="w-5 h-5" />
        </button>
      </div>

      {/* Column headings */}
      <div className="flex items-center justify-between px-5 pt-3 pb-1">
        <span className="text-xs font-semibold text-gray-700">
          Name <span className="font-semibold text-gray-700">(Phone No.)</span>
        </span>
        <span className="text-xs font-semibold text-gray-700">Total Shifts</span>
      </div>

      {/* Body */}
      <div className="overflow-y-auto flex-1 px-5 py-2">
        {referralRecord.referrals?.length > 0 ? (
          <ul className="divide-y divide-gray-100">
            {referralRecord.referrals.map((ref, idx) => (
              <li key={idx} className="flex items-center justify-between py-2.5">
                <div className="flex items-center gap-2.5">
                  <img
                    src={ref.profilePhotoUrl || profile}
                    alt="Profile"
                    style={{
                      width: 32,
                      height: 32,
                      borderRadius: "50%",
                      objectFit: "cover",
                      border: "2px solid #e5e7eb",
                    }}
                  />
                  <div>
                    <div className="text-xs font-medium text-gray-900">{ref.name}</div>
                    <div className="text-gray-400" style={{ fontSize: 10 }}>{ref.phone}</div>
                  </div>
                </div>
                <span className="text-xs font-semibold text-gray-800">{ref.shift}</span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-center text-gray-400 text-xs py-8">
            No referral details available
          </p>
        )}
      </div>

      {/* Footer */}
      <div className="px-5 py-3 border-t bg-gray-50 rounded-b-xl">
        <p className="text-xs text-gray-500 text-right">
          Referral Amount:{" "}
          <span className="font-semibold text-gray-800">
            ₹{referralRecord.referralAmount}
          </span>
        </p>
      </div>
    </div>
  </div>
)}

      </div>
}
  
    </>
  );
};

export default ReferralPayoutFile;